import { render, staticRenderFns } from "./GeneralRules.vue?vue&type=template&id=0116eaaa&"
import script from "./GeneralRules.vue?vue&type=script&lang=js&"
export * from "./GeneralRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports